import React from 'react';
import { Typography, Box } from '@mui/material';
import PageContainer from '../components/PageContainer';
import UserInvitations from '../components/UserInvitations';

export default function InvitationsPage() {
  return (
    <PageContainer>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Invitations
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your group invitations and join requests.
        </Typography>
      </Box>

      <UserInvitations />
    </PageContainer>
  );
}
